var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index_box"},[_c('back-log'),_c('turn-over'),_c('orders-received')],1)}
var staticRenderFns = []

export { render, staticRenderFns }